import React, { useEffect, useState } from 'react';
import TagManager from 'react-gtm-module';
import { reportsList } from '../../../services/api';
import { CampaignHeaderWithLinks } from '../../../components/Campanhas/CampaignHeader';
import Table from '../../../components/Campanhas/Table';

const CampaignReports = () => {
	const [recurringData, setRecurringData] = useState([]);

	useEffect(() => {
		TagManager.dataLayer({
			dataLayer: {
				event: 'PageView',
				page: 'Listagem de relatórios',
			},
			dataLayerName: 'Campanhas',
		});
	}, []);

    useEffect(() => {
        reportsList.recurrent().then((res) => {
			if (res.data.demands !== undefined) {
				setRecurringData(res.data.demands.map(i => i.attributes));
			}
		});
	}, []);


    return (
	<>
		<div style={{ padding: '30px 38px 0' }}>
			<CampaignHeaderWithLinks>Relatórios</CampaignHeaderWithLinks>
			<Table title="Campanhas pontuais" tableData={[]} target="report" />
			<Table title="Campanhas" marginTop="30px" tableData={recurringData} target="report" />
		</div>
	</>
    );
};
export default CampaignReports;
